import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

export const zrxApiParams = {
    apiBaseUrl: {
        [BLOCKCHAIN_NAME.ETHEREUM]: 'https://api.0x.org/'
    },
    nativeTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
};
